import { DebitMandateStatus } from "../../collection/models/DebitMandateStatus";
import { PortalMandateResponse } from "../contracts/PortalMandateResponse";
import { PortalPayment } from "../models/PortalPayment";

/** The one action a Money row offers. */
export type PortalPaymentAction = "pay" | "confirm-and-pay" | "set-up-debit" | "pending" | "none";

/**
 * A card charge the bank wants confirmed offers its pay link (PD-0043); a debit in flight shows its state; a payable row offers Pay now with an active mandate, or leads
 * to the mandate card when one can be set up; everything else (Received, Draft, Voided, a school
 * that collects no direct debit, the mandate still loading) offers nothing.
 */
export const portalPaymentAction = (
  payment: Pick<PortalPayment, "canPayNow" | "pendingDebit" | "payLinkUrl">,
  mandate: PortalMandateResponse | undefined,
): PortalPaymentAction => {
  if (payment.payLinkUrl) return "confirm-and-pay";
  if (payment.pendingDebit) return "pending";
  if (!payment.canPayNow || !mandate) return "none";
  if (mandate.status === DebitMandateStatus.Active) return "pay";
  return mandate.setupAvailable ? "set-up-debit" : "none";
};
